import apiClient from './client';
import type { UpdateUserRequest, User } from '../types/auth';
import type { ClearHistoryResponse } from '../types/problems';

export const userApi = {
  updateProfile: async (data: UpdateUserRequest): Promise<User> => {
    const response = await apiClient.put<User>('/users/me', data);
    return response.data;
  },

  /**
   * Clear all problem history for the current user (v1.4).
   * T119: API call for Clear Problem History feature.
   */
  clearProblemHistory: async (): Promise<ClearHistoryResponse> => {
    const response = await apiClient.delete<ClearHistoryResponse>('/users/me/problem-history');
    return response.data;
  },
};
